import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ConfirmationDialogOptions} from '../../services/confirmation-dialog-options';
import {ConfirmationDialogType} from '../../services/confirmation-dialog-type';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 're-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  options: ConfirmationDialogOptions = null;

  constructor(private activeModal: NgbActiveModal, private router: Router, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.body = this.domSanitizer.bypassSecurityTrustHtml(this.options.body);
  }

  body: SafeHtml;

  getIconClass() {
    if (this.options.modalType == ConfirmationDialogType.Danger)
      return "fa-triangle-exclamation neo-danger";
    if (this.options.modalType == ConfirmationDialogType.Warning)
      return "fa-warning neo-warning";

    return "";

  }
  getDefaultButtonClass() {
    if (this.options.modalType == ConfirmationDialogType.Danger)
      return "btn-danger";
    if (this.options.modalType == ConfirmationDialogType.Warning)
      return "btn-warning";

    return "";

  }
  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
